import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AppointmentSlot } from '../../../modules/appointment/appointment.types'

@Component({
  selector: 'drr-appointment-list-slot',
  templateUrl: './appointment-list-slot.component.html',
  styleUrls: ['./appointment-list-slot.component.scss'],
})
export class AppointmentListSlotComponent {
  @Input() appointmentSlots: AppointmentSlot[] = []
  @Input() selectedSlot: AppointmentSlot = null

  @Output() onSelected = new EventEmitter<AppointmentSlot | null>()

  handleRadioChange(event: any): void {
    const selectedValue = event.detail.value
    this.selectedSlot = selectedValue === 'now' ? null : selectedValue
    this.onSelected.emit(this.selectedSlot)
  }

  compareSlots = (a: AppointmentSlot, b: AppointmentSlot): boolean => {
    if (typeof a === 'string') {
      return a === b;
    }
    if (!a.startTime && !a.endTime || !b.startTime && !b.endTime) {
      return false;
    }
    return a.startTime.getTime() === b.startTime.getTime() &&
      a.endTime.getTime() === b.endTime.getTime()
  }
}
